import {Injectable, OnDestroy} from '@angular/core';
import {AbstractSearchService} from '../../../../core/service/v2/service/search/abstractSearch.service';
import {PartnerModel} from '../model/partner.model';
import {PartnerSummaryModel} from '../model/partnerSummary.model';
import {PartnerRepository} from '../../impl/service/ngrx/partner.repository';
import {PartnerSummaryDataServiceAdapter} from '../../impl/service/ngrx/partnerSummaryDataService.adapter';

@Injectable()
export class PartnerSearchService extends AbstractSearchService<PartnerModel, PartnerSummaryModel> implements OnDestroy {
    constructor(repository: PartnerRepository, dataServiceAdapter: PartnerSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter, 'name');
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
